/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>auhtorization.directive.ts</name>
///
/// <description>
///  
///  
///  
/// </description>
///
/// <author>Scott Grau</author>
/// <created>11 Jan 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 11Jan2017  1.0.0000         First cut 
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Directive, ElementRef, Input ,HostListener, OnInit} from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HydUser } from '../../models/user';
import { Rule } from './rule.model'
import { AuthorizationService } from './authorization.service';


@Directive({ selector: '[PortalAuthorization]' })
export class AuthorizationDirective implements OnInit {

    @Input() UIKey:String;
    @Input() GroupId:String;
   
    constructor(private el: ElementRef,  
                    private hydUser : HydUser, 
                    private http:Http, 
                    private authorizationService: AuthorizationService) {   
                           
    } 

    ngOnInit() {

        if(this.GroupId == undefined || this.GroupId == null   ) {
            this.authorizationService.isAuthorized(this.UIKey).subscribe(isAuthorized => {
                    if(!isAuthorized)
                    {
                     //   console.log(  "********************User is not Authorized for " + this.UIKey + "*****************" )                                                

                        this.el.nativeElement.style.display = "none";
                        try {
                            this.el.nativeElement.remove(); 
                        }
                        catch(ex)  {                          
                        }
                    }               
            });              
        }
        else
        {
         
            this.authorizationService.hasAccess(this.UIKey, this.GroupId).subscribe(isAuthorized => {
                 if(!isAuthorized)
                 {
                   //  console.log(  "********************User is not Authorized for " + this.UIKey + " GroupID :" + this.GroupId + "  *****************" )
                        this.el.nativeElement.style.opacity = ".50"
                        this.el.nativeElement.style.pointerEvents = "none";                                   
                 }                 
            });   
        }

    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authorization/shared/authorization.directive.ts